import moment from "moment";

import "moment/locale/pl";
import "moment/locale/en-gb";

moment.locale((window as any).qdesk.regional.locale);

export default () => {
	return {
		format: function (value, format) {
			return moment(value).format(format);
		},
		parse: function (value, format) {
			return moment(value, format, true).toDate();
		}
	}
}